const CustomDialogStyles = {
  commonDialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    "@media(max-width:600px)": {
      fontSize: "1rem",
    },
  },
  commonDialogContent: {
    // background: "linear-gradient(180deg, #FBFDFC 0%, #E5F6FE 100%)",
    paddingTop: "20px !important",
    paddingBottom: "20px !important",
    paddingLeft: "24px !important",
    paddingRight: "24px !important",
    maxHeight: "70vh",
    overflowY: "auto",
    "& .content-section": {
      "& h3": {
        color: "#20a7db",
        fontSize: "18px",
        fontWeight: 600,
        marginBottom: "12px",
        marginTop: "20px",
        borderBottom: "2px solid #e3f2fd",
        paddingBottom: "8px",
      },
      "& h4": {
        color: "#424242",
        fontSize: "16px",
        fontWeight: 600,
        marginBottom: "8px",
        marginTop: "16px",
      },
      "& p": {
        marginBottom: "12px",
        lineHeight: 1.6,
        color: "#333",
      },
      "& ul": {
        marginBottom: "16px",
        paddingLeft: "20px",
      },
      "& li": {
        marginBottom: "8px",
        lineHeight: 1.5,
      },
      "& strong": {
        color: "#20a7db",
        fontWeight: 600,
      },
      "& .highlight-box": {
        background: "#f5f5f5",
        borderLeft: "4px solid #20a7db",
        padding: "16px",
        margin: "16px 0",
        borderRadius: "4px",
      },
      "& .example-box": {
        background: "#e8f5e8",
        border: "1px solid #1c9d8a",
        padding: "16px",
        margin: "16px 0",
        borderRadius: "4px",
      },
      "& .warning-box": {
        background: "#fff3e0",
        border: "1px solid #FFAC1C",
        padding: "16px",
        margin: "16px 0",
        borderRadius: "4px",
      },
      "& .recommendation-box": {
        background: "#e3f2fd",
        border: "1px solid #20a7db",
        padding: "16px",
        margin: "16px 0",
        borderRadius: "4px",
      },
    },
  },
  commonDialogActions: { padding: "10px" },
};

export default CustomDialogStyles;
